import React, { Component } from "react";
import axios from 'axios'
import { BASEURL } from "../Config"
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { getBookInfo, getChapterInfo, getTopicInfo } from "../modules/reducers";
import { connect } from "react-redux";
import { withRouter, NavLink } from 'react-router-dom';
import { compose } from "redux";

class AddQuestions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [{
                qtype: "mcq",
                qtitle: "",
                ctype: "",
                ilevel: "",
                dlevel: "",
                options: [{
                    answer: "",
                    isCorrect: false
                }],
                subQuestions: [{
                    subq: "",
                    suba: ""
                }],
                tfOptions: [
                    {
                        answer: "True",
                        isCorrect: false
                    },
                    {
                        answer: "False",
                        isCorrect: false
                    }
                ],
                isCollapsed: false,
            }]
        }
    }

    componentDidMount() {
        console.log('book', this.props.book)
        console.log('chapter', this.props.chapter)
        console.log('topic', this.props.topic)
    }

    handleOnClickCollapseOpenBtn(e, idx) {
        e.preventDefault();
        let data = this.state.data;
        data[idx]['isCollapsed'] = false;
        this.setState({
            data
        })
    }

    handleOnClickCollapseCloseBtn(e, idx) {
        e.preventDefault();
        let data = this.state.data;
        data[idx]['isCollapsed'] = true;
        this.setState({
            data
        })
    }

    handleOnAddQuestion(e) {
        e.preventDefault();
        let data = this.state.data;
        data.push({
            qtype: "mcq",
            qtitle: "",
            ctype: "",
            ilevel: "",
            dlevel: "",
            options: [{
                answer: "",
                isCorrect: false
            }],
            subQuestions: [{
                subq: "",
                suba: ""
            }],
            tfOptions: [
                {
                    answer: "True",
                    isCorrect: false
                },
                {
                    answer: "False",
                    isCorrect: false
                }
            ],
            isCollapsed: false,
        })
        this.setState({
            data
        })
    }

    handleOnDeleteQuestion(e, idx) {
        e.preventDefault();
        let data = this.state.data;
        data.splice(idx, 1);
        this.setState({
            data,
        });
    }

    handleQtypeChange(e, idx) {
        let data = this.state.data;
        data[idx] = {
            qtype: "mcq",
            qtitle: "",
            ctype: "",
            ilevel: "",
            dlevel: "",
            options: [{
                answer: "",
                isCorrect: false
            }],
            subQuestions: [{
                subq: "",
                suba: ""
            }],
            tfOptions: [
                {
                    answer: "True",
                    isCorrect: false
                },
                {
                    answer: "False",
                    isCorrect: false
                }
            ],
            isCollapsed: false,
        }
        data[idx][e.target.name] = e.target.value;
        this.setState({
            data
        })
    }

    handleChange(e, idx) {
        let data = this.state.data;
        data[idx][e.target.name] = e.target.value;
        this.setState({
            data
        })
    }

    handleOnChangeOptions(field, value, idx, idx1) {
        let data = this.state.data;
        let options = data[idx].options;
        if (field === "answer") {
            options[idx1][field] = value;
        } else {
            for (let i = 0; i < data[idx].options.length; i++) {
                data[idx].options[i].isCorrect = false;
            }
            options[idx1][field] = value;
        }
        this.setState({
            data
        })
    }

    handleOnAddOptions(e, idx) {
        e.preventDefault();
        let data = this.state.data;
        let options = data[idx].options;
        options.push({
            answer: "",
            isCorrect: false
        })
        this.setState({
            data
        })
    }

    handleOnDeleteOptions(e, idx, idx1) {
        e.preventDefault();
        let data = this.state.data;
        let options = data[idx].options;
        options.splice(idx1, 1);
        this.setState({
            data
        })
    }

    handleOnChangefibOptions(value, idx, idx1) {
        let data = this.state.data;
        let options = data[idx].options;
        options[idx1]['answer'] = value;
        options[idx1]['isCorrect'] = true;
        this.setState({
            data
        })
    }

    handleOnChangetfOptions(value, idx, idx1) {
        let data = this.state.data;
        let tfOptions = data[idx].tfOptions;
        for (let i = 0; i < data[idx].tfOptions.length; i++) {
            data[idx].tfOptions[i].isCorrect = false;
        }
        tfOptions[idx1]['isCorrect'] = value;
        this.setState({
            data
        })
    }

    handleOnChangesubQuestions(field, value, idx, idx1) {
        let data = this.state.data;
        let subQuestions = data[idx].subQuestions;
        subQuestions[idx1][field] = value;
        this.setState({
            data
        })
    }

    handleOnDeletesubQuestions(e, idx, idx1) {
        e.preventDefault();
        let data = this.state.data;
        let subQuestions = data[idx].subQuestions;
        subQuestions.splice(idx1, 1);
        this.setState({
            data
        })
    }

    handleOnAddSubQuestions(e, idx) {
        e.preventDefault();
        let data = this.state.data;
        let subQuestions = data[idx].subQuestions;
        subQuestions.push({
            subq: "",
            suba: ""
        })
        this.setState({
            data
        })
    }

    handleSubmit() {
        console.log('data', this.state.data);
        let data = this.state.data;
        let questionsData = [];
        for (let i in data) {
            let qObject = {};
            qObject.bid = this.props.book._id;
            qObject.cid = this.props.chapter._id;
            qObject.tid = this.props.topic._id;
            qObject.qtitle = data[i].qtitle;
            qObject.qtype = data[i].qtype;
            qObject.ctype = data[i].ctype;
            qObject.dlevel = data[i].dlevel;
            qObject.ilevel = data[i].ilevel;
            qObject.options = [];
            qObject.subQuestions = [];
            if (data[i].qtype === "mcq" || data[i].qtype === "fib" || data[i].qtype === "jwords" || data[i].qtype === "mn") { 
                qObject.options = data[i].options;
            } else if (data[i].qtype === "tf") {
                qObject.options = data[i].tfOptions;
            } else if (data[i].qtype === "mtf" || data[i].qtype === "jw" || data[i].qtype === "meanings") {
                qObject.subQuestions = data[i].subQuestions;
            }
            questionsData.push(qObject);
        }
        console.log('questions data', questionsData);
        axios.post(`${BASEURL}/api/v1/questions/createQuestions`, questionsData)
            .then(res => {
                if (res.status === 200) {
                    console.log('res.data', res.data);
                    window.location = 'questions';
                }
            })
            .catch((err) => {
                console.log('Create Questions Error', err);
            })
    }

    render() {
        return (
            <div id="wrapper">
                <Sidebar act="books" />
                {/* Content Wrapper */}
                <div className="content-page">
                    {/* Main Content */}
                    <div className="content">
                        <Topbar act="Add Questions" breadcrumbItems={['Test Generator', { label: 'Books', path: '/books' }, { label: 'Chapters', path: '/chapters' }, { label: 'Topics', path: '/topics' }, 'Add Questions']} />
                        {/* container */}
                        {/* content */}
                        <div className="container-fluid main-container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card main-card">
                                        <div className="card-body questions-card-body">
                                            {this.state.data.map((item, idx) => (
                                                <div className="questionsDiv">
                                                    {item.isCollapsed ?
                                                        <>
                                                            <div className="d-flex">
                                                                <span className="question-no">Question {idx + 1}</span>
                                                                <div className="collapse-btn-div">
                                                                    <button className="btn" onClick={(e) => this.handleOnClickCollapseOpenBtn(e, idx)}><i className="uil-angle-down"></i></button>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <p className="questionText">{item.qtitle ? item.qtitle : 'Untitled Question'}</p>
                                                                {item.qtype === "mcq" ? <p className="questionType">Multiple Choice Question</p> : null}
                                                                {item.qtype === "fib" ? <p className="questionType">Fill in the Blanks</p> : null}
                                                                {item.qtype === "vsaq" ? <p className="questionType">Very Short Answer Questions</p> : null}
                                                                {item.qtype === "saq" ? <p className="questionType">Short Answer Questions</p> : null}
                                                                {item.qtype === "laq" ? <p className="questionType">Long Answer Questions</p> : null}
                                                                {item.qtype === "tf" ? <p className="questionType">True or False</p> : null}
                                                                {item.qtype === "dad" ? <p className="questionType">Do as Directed</p> : null}
                                                                {item.qtype === "mtf" ? <p className="questionType">Match the Following</p> : null}
                                                                {item.qtype === "ow" ? <p className="questionType">One Word</p> : null}
                                                                {item.qtype === "jwords" ? <p className="questionType">Jumbled Words</p> : null}
                                                                {item.qtype === "mn" ? <p className="questionType">Meanings</p> : null}
                                                            </div>
                                                        </>
                                                        :
                                                        <>
                                                            <div className="row">
                                                                <div className="d-flex">
                                                                    <span className="question-no">Question {idx + 1}</span>
                                                                    <div className="collapse-btn-div">
                                                                        <button className="btn" onClick={(e) => this.handleOnClickCollapseCloseBtn(e, idx)}><i className="uil-angle-up"></i></button>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <div className="form-group mb-3">
                                                                        <select className="form-select"
                                                                            onChange={(e) => this.handleQtypeChange(e, idx)}
                                                                            name="qtype" value={item.qtype}>
                                                                            <option value="mcq">Multiple Choice Questions</option>
                                                                            <option value="fib">Fill in the Blanks</option>
                                                                            <option value="vsaq">Very Short Answer Questions</option>
                                                                            <option value="saq">Short Answer Questions</option>
                                                                            <option value="laq">Long Answer Questions</option>
                                                                            <option value="tf">True or False</option>
                                                                            <option value="dad">Do as Directed</option>
                                                                            <option value="mtf">Match the following</option>
                                                                            <option value="ow">One Word</option>
                                                                            <option value="jwords">Jumbled Words</option>
                                                                            <option value="mn">Meanings</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <div className="form-group mb-3">
                                                                        <select className="form-select"
                                                                            onChange={(e) => this.handleChange(e, idx)}
                                                                            name="ctype" value={item.ctype}>
                                                                            <option value="">Select category</option>
                                                                            <option value="conceptual">Conceptual Understanding</option>
                                                                            <option value="interpretational">Interpretational Skills</option>
                                                                            <option value="information">Information Skills</option>
                                                                            <option value="problemsolving">Problem Solving</option>
                                                                            <option value="analytical">Analytical Thinking</option>
                                                                            <option value="appskills">Applicational Skills</option>
                                                                            <option value="higherorder">Higher Order Thinking</option>
                                                                            <option value="algothinking">Algorithmic Thinking Skills</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <div className="form-group mb-3">
                                                                        <select className="form-select"
                                                                            onChange={(e) => this.handleChange(e, idx)}
                                                                            name="dlevel" value={item.dlevel}>
                                                                            <option value="">Select Difficulty Level</option>
                                                                            <option value="low">Low</option>
                                                                            <option value="medium">Medium</option>
                                                                            <option value="high">High</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <div className="form-group mb-3">
                                                                        <select className="form-select"
                                                                            onChange={(e) => this.handleChange(e, idx)}
                                                                            name="ilevel" value={item.ilevel}>
                                                                            <option value="">Select Importance Level</option>
                                                                            <option value="low">Low</option>
                                                                            <option value="medium">Medium</option>
                                                                            <option value="high">High</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-xl-12">
                                                                    <div className="mb-3">
                                                                        <textarea
                                                                            class="form-control"
                                                                            rows="3"
                                                                            name="qtitle"
                                                                            placeholder="Enter your Question"
                                                                            value={item.qtitle}
                                                                            onChange={(e) => this.handleChange(e, idx)}>
                                                                        </textarea>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {item.qtype === "mcq" ?
                                                                <>
                                                                    <div className="answer_header">
                                                                        <p className="answers_title">Answers</p>
                                                                        <p>Select Correct Answer</p>
                                                                    </div>
                                                                    {item.options.map((item1, idx1) => (
                                                                        <div className="form-group col-md-12 mb-2">
                                                                            <div className="input-group">
                                                                                <input type="text" className="form-control"
                                                                                    placeholder="Enter Answer"
                                                                                    defaultValue={item1.answer}
                                                                                    onChange={(e) =>
                                                                                        this.handleOnChangeOptions(
                                                                                            "answer",
                                                                                            e.target.value,
                                                                                            idx,
                                                                                            idx1
                                                                                        )
                                                                                    }
                                                                                />
                                                                                <div className="input-group-append">
                                                                                    <div className="input-group-text answerRadioBtn">
                                                                                        <div className="custom-control custom-radio">
                                                                                            <input type="radio"
                                                                                                name={`isCorrect${idx}`}
                                                                                                className="custom-control-input"
                                                                                                defaultChecked={item1.isCorrect}
                                                                                                onChange={(e) =>
                                                                                                    this.handleOnChangeOptions(
                                                                                                        "isCorrect",
                                                                                                        true,
                                                                                                        idx,
                                                                                                        idx1
                                                                                                    )
                                                                                                } />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <button
                                                                                    className="btn deleteAnswerBtn"
                                                                                    onClick={(e) =>
                                                                                        this.handleOnDeleteOptions(e, idx, idx1)
                                                                                    }
                                                                                >
                                                                                    <i class="uil-times"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                    <button type="button"
                                                                        className="btn btn-customprimary"
                                                                        style={{ opacity: "50%" }}
                                                                        onClick={(e) => this.handleOnAddOptions(e, idx)}>
                                                                        <i className="mdi mdi-plus-circle"></i> Add Options</button>
                                                                </>
                                                                : ''}
                                                            {item.qtype === "fib" || item.qtype === "jwords" || item.qtype === "mn" ?
                                                                <>
                                                                    {item.options.map((item1, idx1) => (
                                                                        <div className="form-group col-md-6 mb-2">
                                                                            <input type="text" className="form-control"
                                                                                placeholder="Enter Answer"
                                                                                defaultValue={item1.answer}
                                                                                onChange={(e) =>
                                                                                    this.handleOnChangefibOptions(
                                                                                        e.target.value,
                                                                                        idx,
                                                                                        idx1
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div>
                                                                    ))}
                                                                </>
                                                                : ''}
                                                            {item.qtype === "tf" ?
                                                                <>
                                                                    {item.tfOptions.map((item1, idx1) => (
                                                                        <div className="form-group col-md-12 mb-2">
                                                                            <div className="input-group">
                                                                                <input type="text" className="form-control bgtf"
                                                                                    placeholder="Enter Answer"
                                                                                    defaultValue={item1.answer}
                                                                                    disabled
                                                                                />
                                                                                <div className="input-group-append">
                                                                                    <div className="input-group-text answerRadioBtn">
                                                                                        <div className="custom-control custom-radio">
                                                                                            <input type="radio"
                                                                                                name={`isCorrect${idx}`}
                                                                                                className="custom-control-input"
                                                                                                defaultChecked={item1.isCorrect}
                                                                                                onChange={(e) =>
                                                                                                    this.handleOnChangetfOptions(
                                                                                                        true,
                                                                                                        idx,
                                                                                                        idx1
                                                                                                    )
                                                                                                } />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <button
                                                                                    className="btn deleteAnswerBtn"
                                                                                    onClick={(e) =>
                                                                                        this.handleOnDeleteOptions(e, idx, idx1)
                                                                                    }
                                                                                >
                                                                                    <i class="uil-times"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </>
                                                                : ''}

                                                            {item.qtype === "mtf" ?
                                                                <>
                                                                    <div className="answer_header">
                                                                        <p className="answers_title">Questions</p>
                                                                        <p className="answers_title1">Answers</p>
                                                                    </div>
                                                                    {item.subQuestions.map((item1, idx1) => (
                                                                        <div className="form-group col-md-12">
                                                                            <div className="input-group subQuestionsGroup">
                                                                                <input type="text" className="form-control subq"
                                                                                    placeholder="Enter Question"
                                                                                    defaultValue={item1.subq}
                                                                                    onChange={(e) =>
                                                                                        this.handleOnChangesubQuestions(
                                                                                            "subq",
                                                                                            e.target.value,
                                                                                            idx,
                                                                                            idx1
                                                                                        )
                                                                                    }
                                                                                />
                                                                                <div className="delimiter"></div>
                                                                                <input type="text" className="form-control suba"
                                                                                    placeholder="Enter Answer"
                                                                                    defaultValue={item1.suba}
                                                                                    onChange={(e) =>
                                                                                        this.handleOnChangesubQuestions(
                                                                                            "suba",
                                                                                            e.target.value,
                                                                                            idx,
                                                                                            idx1
                                                                                        )
                                                                                    }
                                                                                />
                                                                                <button
                                                                                    className="btn deleteAnswerBtn"
                                                                                    onClick={(e) =>
                                                                                        this.handleOnDeletesubQuestions(e, idx, idx1)
                                                                                    }
                                                                                >
                                                                                    <i class="uil-times"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                    <button type="button"
                                                                        className="btn btn-customprimary"
                                                                        style={{ opacity: "50%" }}
                                                                        onClick={(e) => this.handleOnAddSubQuestions(e, idx)}>
                                                                        <i className="mdi mdi-plus-circle"></i> Add Questions</button>
                                                                </>
                                                                : ''}
                                                            {item.qtype === "jw" ?
                                                                <>
                                                                    <div className="answer_header">
                                                                        <p className="answers_title">Questions</p>
                                                                        <p className="answers_title1">Answers</p>
                                                                    </div>
                                                                    {item.subQuestions.map((item1, idx1) => (
                                                                        <div className="form-group col-md-12">
                                                                            <div className="input-group subQuestionsGroup">
                                                                                <input type="text" className="form-control subq"
                                                                                    placeholder="Enter Question"
                                                                                    defaultValue={item1.subq}
                                                                                    onChange={(e) =>
                                                                                        this.handleOnChangesubQuestions(
                                                                                            "subq",
                                                                                            e.target.value,
                                                                                            idx,
                                                                                            idx1
                                                                                        )
                                                                                    }
                                                                                />
                                                                                <div className="delimiter"></div>
                                                                                <input type="text" className="form-control suba"
                                                                                    placeholder="Enter Answer"
                                                                                    defaultValue={item1.suba}
                                                                                    onChange={(e) =>
                                                                                        this.handleOnChangesubQuestions(
                                                                                            "suba",
                                                                                            e.target.value,
                                                                                            idx,
                                                                                            idx1
                                                                                        )
                                                                                    }
                                                                                />
                                                                                <button
                                                                                    className="btn deleteAnswerBtn"
                                                                                    onClick={(e) =>
                                                                                        this.handleOnDeletesubQuestions(e, idx, idx1)
                                                                                    }
                                                                                >
                                                                                    <i class="uil-times"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                    <button type="button"
                                                                        className="btn btn-customprimary"
                                                                        style={{ opacity: "50%" }}
                                                                        onClick={(e) => this.handleOnAddSubQuestions(e, idx)}>
                                                                        <i className="mdi mdi-plus-circle"></i> Add Questions</button>
                                                                </>
                                                                : ''}
                                                            {item.qtype === "meanings" ?
                                                                <>
                                                                    <div className="answer_header">
                                                                        <p className="answers_title">Questions</p>
                                                                        <p className="answers_title1">Answers</p>
                                                                    </div>
                                                                    {item.subQuestions.map((item1, idx1) => (
                                                                        <div className="form-group col-md-12">
                                                                            <div className="input-group subQuestionsGroup">
                                                                                <input type="text" className="form-control subq"
                                                                                    placeholder="Enter Question"
                                                                                    defaultValue={item1.subq}
                                                                                    onChange={(e) =>
                                                                                        this.handleOnChangesubQuestions(
                                                                                            "subq",
                                                                                            e.target.value,
                                                                                            idx,
                                                                                            idx1
                                                                                        )
                                                                                    }
                                                                                />
                                                                                <div className="delimiter"></div>
                                                                                <input type="text" className="form-control suba"
                                                                                    placeholder="Enter Answer"
                                                                                    defaultValue={item1.suba}
                                                                                    onChange={(e) =>
                                                                                        this.handleOnChangesubQuestions(
                                                                                            "suba",
                                                                                            e.target.value,
                                                                                            idx,
                                                                                            idx1
                                                                                        )
                                                                                    }
                                                                                />
                                                                                <button
                                                                                    className="btn deleteAnswerBtn"
                                                                                    onClick={(e) =>
                                                                                        this.handleOnDeletesubQuestions(e, idx, idx1)
                                                                                    }
                                                                                >
                                                                                    <i class="uil-times"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                    <button type="button"
                                                                        className="btn btn-customprimary"
                                                                        style={{ opacity: "50%" }}
                                                                        onClick={(e) => this.handleOnAddSubQuestions(e, idx)}>
                                                                        <i className="mdi mdi-plus-circle"></i> Add Questions</button>
                                                                </>
                                                                : ''}
                                                            {idx !== 0 ?
                                                                <button type="button"
                                                                    className="btn btn-outline-primary delete-question-btn"
                                                                    onClick={(e) => this.handleOnDeleteQuestion(e, idx)}>
                                                                    Delete Question</button> : ''}
                                                        </>
                                                    }
                                                </div>
                                            ))}

                                            {/* end row */}
                                        </div> {/* end card-body */}
                                    </div> {/* end card*/}
                                    <div className="d-flex">
                                        <button type="button" class="btn btn-primary mr-2" onClick={(e) => this.handleOnAddQuestion(e)}><i className="mdi mdi-plus-circle"></i> Add New Question</button>
                                        <button type="submit" class="btn btn-customprimary" onClick={() => this.handleSubmit()}>Submit Questions</button>
                                    </div>

                                </div> {/* end col*/}
                            </div>
                            {/* end row*/}
                        </div>
                        {/* End of Main Content */}
                        <Footer />
                    </div>
                    {/* End of Content Wrapper */}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        book: getBookInfo(state),
        chapter: getChapterInfo(state),
        topic: getTopicInfo(state)
    }
}

export default compose(withRouter, connect(mapStateToProps))(AddQuestions);